const MIDDOT = '\u2022';
const MASKED_BLOCK = MIDDOT.repeat(4);
const BLOCK_SEPARATOR = ' ';

export const useCreditCardFormatter = () => {
  function maskCardNumber(lastFourOrFull: string): string {
    const last4 = lastFourOrFull.replace(/\s/g, '').slice(-4);

    return [MASKED_BLOCK, MASKED_BLOCK, MASKED_BLOCK, last4].join(BLOCK_SEPARATOR);
  }

  return {
    maskCardNumber,
  };
};
